<mat-tab-group mat-stretch-tabs>
  <mat-tab label="{{ 'Modules.Licenses.List.Expired.TabHeader' | translate }}">
    <ng-template matTabContent>
      <xpac-licenses-list-tab [title]="'Modules.Licenses.List.Expired.Title' | translate" [isCrossPoint]="hasCrossPointRole()" [expired]="true"></xpac-licenses-list-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="{{ 'Modules.Licenses.List.Expiring.TabHeader' | translate }}">
    <ng-template matTabContent>
      <xpac-licenses-list-tab [title]="'Modules.Licenses.List.Expiring.Title' | translate" [isCrossPoint]="hasCrossPointRole()" [expiring]="true" [expired]="false"></xpac-licenses-list-tab>
    </ng-template>
  </mat-tab> 
  <mat-tab label="{{ 'Modules.Licenses.List.Active.TabHeader' | translate }}">
    <ng-template matTabContent>
      <xpac-licenses-list-tab [title]="'Modules.Licenses.List.Active.Title' | translate" [isCrossPoint]="hasCrossPointRole()" [expired]="false"></xpac-licenses-list-tab>
    </ng-template>
  </mat-tab>
  <mat-tab label="{{ 'Modules.Licenses.List.OrderHistory.TabHeader' | translate }}">
    <ng-template matTabContent>
      <xpac-order-history></xpac-order-history>
    </ng-template>
  </mat-tab>
</mat-tab-group>